export const SizeUnits = ['%', 'em', 'px', 'rem', 'vh', 'vw'] as const;
export type SizeUnit = (typeof SizeUnits)[number];

export type UnitlessSize<T extends number = number> = `${T}` | T;

export type QuantitativeSizeString<
  U extends SizeUnit = SizeUnit,
  N extends UnitlessSize = UnitlessSize,
> = `${N}${U}`;

/**
 * Represents the manner in which a concrete, numeric size can be specified for
 * a given CSS property.
 *
 * @example
 * const size: QuantitativeSize = "30px";
 * const size: QuantitativeSize = "30";
 * const size: QuantitativeSize = "30.1";
 * const size: QuantitativeSize = 30;
 */
export type QuantitativeSize<
  U extends SizeUnit = SizeUnit,
  N extends UnitlessSize = UnitlessSize,
> = N | QuantitativeSizeString<U, N>;

type EitherCase<C extends string> = C | Capitalize<C>;

export type SizeProps<H extends 'height' | 'width' = 'height' | 'width'> = Extract<
  'height' | 'maxHeight' | 'maxWidth' | 'minHeight' | 'minWidth' | 'width',
  `${string}${EitherCase<H>}`
>;
